import { Injectable } from '@angular/core';

@Injectable()
export class RubrikVMService {
  public modelToVM(configuredComponents: Array<string>, availableComponents: Array<string>) {
    const componentVMs: Array<RubrikComponentVM> = [];
    for (const component of configuredComponents) {
      componentVMs.push(new RubrikComponentVM(component, true));
    }
    for (const component of availableComponents.filter((c) => !configuredComponents.includes(c))) {
      componentVMs.push(new RubrikComponentVM(component, false));
    }
    return componentVMs;
  }

  public VMToModel(componentVMs: Array<RubrikComponentVM>): Array<string> {
    const components: Array<string> = [];
    for (const component of componentVMs) {
      components.push(component.name);
    }
    return components;
  }
}

export class RubrikComponentVM {
  public name: string;
  public _visible = false;

  constructor(name: string, visible: boolean) {
    this.name = name;
    this.visible = visible;
  }

  set visible(visible: boolean) {
    this._visible = visible;
  }

  get visible(): boolean {
    return this._visible;
  }

  toggleVisible() {
    this._visible = !this._visible;
  }
}
